const SILENCE_LEVEL = 0.01;
const SAMPLE_MIDPOINT = 128;
const ANALYSER_FFT_SIZE = 512;

function levelFromSamples(samples) {
  if (!samples || !samples.length) {
    return 0;
  }
  let sumOfSquares = 0;
  for (let index = 0; index < samples.length; index += 1) {
    const centred = (samples[index] - SAMPLE_MIDPOINT) / SAMPLE_MIDPOINT;
    sumOfSquares += centred * centred;
  }

  return Math.min(1, Math.sqrt(sumOfSquares / samples.length));
}

function litBarCount(level, bars) {
  if (!bars || level < SILENCE_LEVEL) {
    return 0;
  }

  return Math.min(bars, Math.ceil(Math.sqrt(level) * bars));
}

function createMicLevelMeter(stream, audioContext, onLevel) {
  const audioTracks = stream?.getAudioTracks ? stream.getAudioTracks() : [];
  if (!audioContext || !audioTracks.length || typeof requestAnimationFrame === "undefined") {
    return { stop() {} };
  }
  const source = audioContext.createMediaStreamSource(new MediaStream(audioTracks));
  const analyser = audioContext.createAnalyser();
  analyser.fftSize = ANALYSER_FFT_SIZE;
  source.connect(analyser);
  const samples = new Uint8Array(analyser.fftSize);
  let frame = null;
  const tick = () => {
    analyser.getByteTimeDomainData(samples);
    onLevel(levelFromSamples(samples));
    frame = requestAnimationFrame(tick);
  };
  if (audioContext.state === "suspended") {
    audioContext.resume();
  }
  frame = requestAnimationFrame(tick);

  return {
    stop() {
      if (frame !== null) {
        cancelAnimationFrame(frame);
        frame = null;
      }
      source.disconnect();
      analyser.disconnect();
      onLevel(0);
    },
  };
}

module.exports = {
  SILENCE_LEVEL,
  levelFromSamples,
  litBarCount,
  createMicLevelMeter,
};
